module.exports = __webpack_public_path__ + "static/img/btn.c89ead49.png";